import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { Color } from 'src/app/models/color.model';

export interface ColorsState extends EntityState<Color> {
    loading: boolean;
  }

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'colors' })
export class ColorStore extends EntityStore<ColorsState, Color> {
    constructor() {
      super({ loading: false });
    }
  }
